import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { TLeasingFile, TLeasingOrderDetailed } from '../../../types';
import type { TIeLeasingOrderStore } from './types';

const initialState: TIeLeasingOrderStore = {
  activeTabIndex: 0,
  files: [],
  mappedFiles: {},
  refreshToken: 0,
  request: null
};

export const ieLeasingOrderSlice = createSlice({
  name: 'ieLeasingOrder',
  initialState,
  reducers: {
    resetIeLeasingOrder: () => {
      return initialState;
    },
    setActiveTabIndex: (state, action: PayloadAction<number>) => {
      state.activeTabIndex = action.payload;
    },
    setRequestData: (
      state,
      action: PayloadAction<{
        request: TLeasingOrderDetailed;
        files: TLeasingFile[];
      }>
    ) => {
      const { request: payloadRequest, files: payloadFiles } = action.payload;

      state.files = payloadFiles;

      const mappedFiles: TIeLeasingOrderStore['mappedFiles'] = {};
      payloadFiles.forEach((file) => {
        switch (file.type) {
          case 'clientPhoto':
            mappedFiles.clientPhoto = file;
            break;
          case 'docPhoto':
            mappedFiles.docPhoto = file;
            break;
          case 'docScanSocialStatus':
            mappedFiles.docScanSocialStatus = file;
            break;
          case 'incomeCert':
            mappedFiles.incomeCert = file;
            break;
          case 'noticeActivity':
            mappedFiles.noticeActivity = file;
            break;
          case 'otherDoc':
            mappedFiles.otherDoc = file;
            break;
        }
      });
      state.mappedFiles = mappedFiles;

      state.request = payloadRequest;
      const { request } = state;
      if (request) {
        const { applicationData } = request;
        if (applicationData) {
          const { product } = applicationData;
          if (product) {
            product.proofInCome ??= !!mappedFiles.incomeCert;
          }
        }
      }
    },
    refreshOrderData: (state) => {
      state.refreshToken += 1;
    }
  }
});

export const {
  resetIeLeasingOrder,
  setActiveTabIndex,
  setRequestData,
  refreshOrderData
} = ieLeasingOrderSlice.actions;
